module.exports = __webpack_public_path__ + "img/6869f2d.jpg";